'use client';

import { FormattedMessage } from 'react-intl';

export const NotFoundTastic = () => (
  <div className="container-fluid d-flex py-5 justify-content-center align-items-start text-center">
    <p className="my-0 py-5 text-muted not-found-message">
      <FormattedMessage
        id="payment.checkout.not.found"
        defaultMessage="The page you're looking for is unavailable or there's an error in the URL. Please check the URL and try again."
        description="Not Found Page Message"
      />
    </p>
  </div>
);
